import React from 'react';
import styled from "styled-components"
import {Icon} from "react-materialize";

const StyledDetails = styled.div`
  .report-breakdown {
    .date-selection {
      cursor: pointer;
      border: 1px solid white;
      padding: 2px 26px 2px 10px;
      margin-left: 0.7rem;
      i {
        position: absolute;
      }
    }
  }
  
  .last-sync {
    display: flex;
    justify-content: flex-end;
    width: 40rem;
    font-size: 2rem;
    height: 2.3rem;
    background-color: transparent;
    color: white;
  }
`

const ReportDetails = () => {
  return (
    <StyledDetails>
      <div className={'report-breakdown'}>
        <h3>This Week</h3>
        <div>
          Compared to
          <span className={'date-selection'}>Last Week<Icon>keyboard_arrow_down</Icon>
          </span>
        </div>
      </div>
      <div className={'last-sync'}>
        <p>
          Last Sync Mon 22, 10:00pm (MT)
        </p>
      </div>
    </StyledDetails>
  )
}

export default ReportDetails;